import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class LegacyLicenseSerializer extends ApplicationSerializer {
  attrs = {
    analytics: {
      embedded: 'always',
    },
    assembly: {
      embedded: 'always',
    },
    evision: {
      embedded: 'always',
    },
    jel: {
      embedded: 'always',
    },
    jem: {
      embedded: 'always',
    },
    kitting: {
      embedded: 'always',
    },
    oee: {
      embedded: 'always',
    },
    quality: {
      embedded: 'always',
    },
    trackAndTrace: {
      embedded: 'always',
    },
  };
}
